import moment from 'moment';

export const isTimeBetweenRange = (time, start, end, borders = '[]') => {
  return moment(time, 'HH:mm').isBetween(
    moment(start, 'HH:mm'),
    moment(end, 'HH:mm'),
    'minutes',
    borders
  );
};

export const areTimeRangesCollided = (start1, end1, start2, end2) => {
  const startTime1 = moment(start1, 'HH:mm');
  const endTime1 = moment(end1, 'HH:mm');
  const startTime2 = moment(start2, 'HH:mm');
  const endTime2 = moment(end2, 'HH:mm');

  return (
    (startTime1 >= startTime2 && startTime1 < endTime2) ||
    (endTime1 > startTime2 && endTime1 <= endTime2) ||
    (startTime2 >= startTime1 && startTime2 < endTime1) ||
    (endTime2 > startTime1 && endTime2 <= endTime1)
  );
};
